import { gql } from "@apollo/client";

export const F_ENUM = gql`
    fragment F_ENUM on EnumResponse {
        name
        id: value
    }
`;
